import * as API from './index'

export default {
    get: params => {
        return API.GET('/api/CompetitionHost/Get', params)
    },
    getList: params => {
        return API.GET('/api/CompetitionHost/List', params)
    },
    select: params => {
        return API.GET('/api/CompetitionHost/select', params)
    },
    add: params => {
        return API.POST('/api/CompetitionHost/Add', params)
    },
    edit: params => {
        return API.POST('/api/CompetitionHost/Edit', params)
    },
    delete: params => {
        return API.DELETE('/api/CompetitionHost/delete', params)
    },
    deleteBatch: params => {
        return API.DELETEBATCH('/api/CompetitionHost/DeleteBatch', params)
    },
    register: params => {
        return API.POST('/api/CompetitionHost/Register', params)
    },
    getUser: params => {
        return API.GET('/api/CompetitionHost/GetUser', params)
    },
    matchList:params=>{
        return API.GET('/api/CompetitionHost/MatchList', params)
    }
}


// WEBPACK FOOTER //
// ./src/apis/host.js